"use client";

import { useEffect } from "react";

import { announceReady, forgetJob, watchedJobs } from "../../lib/jobs/notify";
import { getJobSnapshot } from "../../lib/jobs/client";

/**
 * Keeps an eye on rebuilds this browser started, from any page, and says so
 * when one finishes. It does nothing, and asks the server for nothing, until a
 * rebuild has been started here.
 */
export default function JobWatcher() {
  useEffect(() => {
    let timer: ReturnType<typeof setTimeout> | undefined;
    let stopped = false;

    const tick = async () => {
      const ids = watchedJobs();
      for (const id of ids) {
        const job = await getJobSnapshot(id);
        if (!job) {
          forgetJob(id);
        } else if (job.status === "done") {
          announceReady(job.readingTitle, job.readingId);
          forgetJob(id);
        } else if (job.status === "failed") {
          forgetJob(id);
        }
      }
      if (!stopped)
        timer = setTimeout(tick, watchedJobs().length ? 6000 : 15000);
    };

    timer = setTimeout(tick, 4000);
    return () => {
      stopped = true;
      if (timer) clearTimeout(timer);
    };
  }, []);

  return null;
}
